import React from "react";
import { Drawer, Image } from "antd";
import { DetailList, Section, StatusTag, fmtMoney } from "./ui";

const RoomDetailDrawer = ({ open, visible, room, onClose }) => {
  if (!room) return null;

  // Support both props during migration
  const isOpen = open ?? visible ?? false;

  const capacity = room.capacity ?? room.Capacity;
  const priceNum = Number(room.price ?? 0) || 0;
  const currency = room.currency || "BWP";

  const rawQr = room.qrCodeBase64 ?? room.QRCodeBase64 ?? null;
  const qrSrc = rawQr
    ? String(rawQr).startsWith("data:image")
      ? rawQr
      : `data:image/png;base64,${rawQr}`
    : null;

  const roomNumber = room.roomNumber ?? room.RoomNumber ?? "";
  const status = room.status ?? room.Status ?? "Unknown";
  const typeName = room.roomTypeName ?? room.roomType?.typeName;
  const features = room.features ?? room.Features;
  const description = room.description ?? room.Description;

  return (
    <Drawer title="Room details" placement="right" open={isOpen} onClose={onClose} size={560} destroyOnHidden>
      <div className="hms-summary">
        <div>
          <div className="hms-summary-title">Room {roomNumber || "—"}</div>
          <div className="hms-summary-sub">{typeName || "No room type"}</div>
        </div>
        <StatusTag status={status}>{status}</StatusTag>
      </div>

      <DetailList
        items={[
          { label: "Price per night", value: priceNum > 0 ? fmtMoney(currency, priceNum) : "Not set" },
          { label: "Floor", value: room.floor ?? room.Floor },
          { label: "Capacity", value: capacity },
        ]}
      />

      <Section title="Features">{features ? <p style={{ margin: 0 }}>{features}</p> : <span className="hms-muted">None listed</span>}</Section>

      <Section title="Description">
        {description ? <p style={{ margin: 0 }}>{description}</p> : <span className="hms-muted">No description available</span>}
      </Section>

      <Section title="QR code">
        {qrSrc ? (
          <Image src={qrSrc} alt="Room QR code" width={150} preview={false} />
        ) : (
          <span className="hms-muted">No QR code generated</span>
        )}
      </Section>
    </Drawer>
  );
};

export default RoomDetailDrawer;
